export default __webpack_public_path__ + "static/media/hero.576d40a8.png";